import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import cn from "classnames";
import SearchInput from "src/components/common/SearchInput";
import Tabs from "src/components/common/Tabs";
import TabPanel from "src/components/common/TabPanel";
import ManageShopPanel from "src/components/manage/ManageShopPanel";
import ManageComPanel from "src/components/manage/ManageComPanel";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "src/store/actions/action";
import AlarmButton from "src/components/common/AlarmButton";
import { motion } from "framer-motion";
import styled from "styled-components";
import { isEmpty } from "lodash";

function manageList() {
  const sessionStorageOpenTab = window.sessionStorage.getItem("openTab");

  const [openTab, setOpenTab] = useState<number>();
  const [hasAlarm, setHasAlarm] = useState(false);
  const navigate = useNavigate();
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);

  const [contents, setContents] = useState("");

  const parentFunc = (contents: string) => {
    setContents(contents);
  };

  const tab = ["매장정보", "업체정보"];
  const tabItem: any = {
    0: <ManageShopPanel contents={contents} parentFunc={parentFunc} />,
    1: <ManageComPanel contents={contents} parentFunc={parentFunc} />,
  };

  useEffect(() => {
    setOpenTab(0);
  }, []);

  useEffect(() => {
    if (!isEmpty(sessionStorageOpenTab) && typeof sessionStorageOpenTab !== undefined) {
      setOpenTab(Number(sessionStorageOpenTab));
    }
  }, [sessionStorageOpenTab]);

  const tabHandler = (idx: number) => {
    setOpenTab(idx);
  };

  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      searchContents(e);
    }
  };

  const searchContents = (e: any) => {
    setContents(e.currentTarget.parentElement?.childNodes[0].value);
  };

  const deleteSearchContents = () => {
    if (contents) {
      setContents("");
    }
  };

  return (
    <>
      <header className={cn({ hasAlarm: hasAlarm })}>
        <div>
          <Button variant="text" className="btn-back no-ico">
            매장/업체
          </Button>
        </div>
        <div className="btn-box">
          <AlarmButton />
          <IconButton btnName="마이페이지" className="user" onClick={() => navigate("/profile/" + userInfo.user_id)}>
            <SVG name="userBlack" />
          </IconButton>
        </div>
      </header>

      <Body isTabbar={true}>
        <Box pd="20px 15px">
          <SearchInput
            type="text"
            id="search-input"
            placeholder="매장 또는 업체명을 입력해주세요."
            defaultValue={contents}
            onClick={(e) => searchContents(e)}
            onKeyPress={(e) => onKeyPress(e)}
            deleteSearchContentFunc={deleteSearchContents}
          />
        </Box>

        <Tabs>
          <ul>
            {tab.map((v, idx) => {
              return (
                <li
                  className={openTab === idx ? "active" : ""}
                  key={idx}
                  onClick={() => {
                    tabHandler(idx);
                  }}
                >
                  {v}
                  {idx === openTab ? <TabUnderline className="tabUnderline" layoutId="tabUnderline" /> : null}
                </li>
              );
            })}
          </ul>
          <TabPanel>{tabItem[openTab!]}</TabPanel>
        </Tabs>
      </Body>
    </>
  );
}

const TabUnderline = styled(motion.div)`
  /* tab 애니효과 */
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: ${({ theme }) => theme.color.main};
`;

export default manageList;
